let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("idfnC"), load("ky7A9")]).then(() => parcelRequire('9CFr9'));